'use strict';

angular.module('AcaApp').controller('ResetPasswordController', [
  '$scope',
  '$location',
  '$routeParams',
  'UtilsService',
  'AuthenticationService',
  'SecurityService',
  'EXCEPTION',
  'MsgBetweenCtrlService',
  'PASSWORD_MESSAGES',
  /* jscs:disable maximumLineLength, requireCamelCaseOrUpperCaseIdentifiers */
  function($scope, $location, $routeParams, UtilsService, AuthenticationService, SecurityService, EXCEPTION, MsgBetweenCtrlService, PASSWORD_MESSAGES){
    this.startParams = function(){
      $scope.changePass = {};
      $scope.user = {};
      $scope.errorMessage = '';
      $scope.showPasswordRequired = false;
      $scope.showReenterRequired = false;
      $scope.showAnswerRequired = false;
      $scope.specialCharsMsge = PASSWORD_MESSAGES.SPECIAL_CHARS;
      if($routeParams.token){
        $scope.token = $routeParams.token;
        SecurityService.findUserSecurityQuestion($scope.token).then(function(data){
          $scope.step = 1;
          $scope.question = data.result.Question;
          $scope.questionId = data.result.Id;
        },
        function(error){
          if(error.data.error.frontend_code === EXCEPTION.INVALIDTOKEN){
            $scope.step = 4;
          }
          else{
            $scope.errorMessage = (error.data.error.frontend_message || undefined);
          }
        });
      }
      else{
        $scope.cleanURL();
        $location.path('/login');
      }
    };
    $scope.resetPassword = function(form){
      if(form.$valid){
        if($scope.validation()){
          $scope.changePass.token = $scope.token;
          $scope.changePass.newPassword = $scope.user.password1;
          var answerObject = {
            'SecurityAnswers': [
              {'QuestionId': $scope.questionId, 'Answer': $scope.user.answer}
            ]
          };
          AuthenticationService.changePasswordByToken($scope.changePass, answerObject).then(function(data){
            if(data.result.value === true){
              $scope.step = 3;
            }
          },
          function(error){
            if(error.data.error.frontend_code === EXCEPTION.INVALIDTOKEN){
              $scope.step = 4;
            }
            else{
              $scope.errorMessage = (error.data.error.frontend_message || undefined);
            }
          });
        }
      }
      else{
        $scope.eventShowPasswordRequired();
        $scope.eventShowReenterRequired();
      }
    };
    $scope.submitSecurityQuestion = function(answerQuestionForm){
      if(answerQuestionForm.$valid){
        var answerObject = {
          'SecurityAnswers': [
            {'QuestionId': $scope.questionId, 'Answer': $scope.user.answer}
          ]
        };
        SecurityService.validateSecurityAnswer($scope.token, answerObject).then(function(data){
          if(data.result.value === true){
            $scope.errorMessage = '';
            $scope.step = 2;
          }
        },
        function(error){
          if(error.data.error.frontend_code === EXCEPTION.MAXFAILEDLOGINS ||
            error.data.error.frontend_code === EXCEPTION.ACCOUNTDISABLED){
            MsgBetweenCtrlService.data.errorMessage = error.data.error.frontend_message;
            $scope.cleanURL();
            $location.path('/account-locked');
          }
          if(error.data.error.frontend_code === EXCEPTION.INVALIDTOKEN){
            $scope.step = 4;
          }
          else{
            $scope.errorMessage = (error.data.error.frontend_message || undefined);
          }
        });
      }
      else{
        $scope.eventShowAnswerRequiered();
      }
    };
    $scope.backHome = function(){
      $scope.cleanURL();
      $location.path('/login');
    };
    $scope.backForgotPassword = function(){
      $scope.cleanURL();
      $location.path('/forgot-password');
    };
    $scope.validation = function(){
      var passwordValidation = UtilsService.validatePassword(
        $scope.user.password1,
        $scope.user.password2);
      if(!passwordValidation.value){
        $scope.errorMessage = passwordValidation.msg;
        return false;
      }
      else{
        $scope.errorMessage = '';
        return true;
      }
    };
    $scope.eventShowPasswordRequired = function(){
      $scope.showPasswordRequired = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowReenterRequired = function(){
      $scope.showReenterRequired = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowAnswerRequiered = function(){
      $scope.showAnswerRequired = true;
      $scope.errorMessage = '';
    };
    $scope.cleanURL = function(){
      $location.$$search = {};
    };
    this.startParams();
  }
]);
